import { categories } from '@/mocks/mangaData';

const quickNav = [
  { label: '核心功能', href: '#features' },
  { label: '热门追更', href: '#trending' },
  { label: '分类书库', href: '#categories' },
  { label: '使用指南', href: '#guide' },
  { label: '常见问题', href: '#faq' },
];

export default function Footer() {
  return (
    <footer className="bg-primary-900 text-background-100">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <a href="#top" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-background-50 text-primary-700">
                <i className="ri-flower-line text-xl" />
              </span>
              <span className="font-heading text-lg font-bold text-background-50">樱花漫画</span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-100/80">
              樱花漫画追更提醒服务，收藏订阅、书架管理、多端进度同步，缓存章节随时读，让你喜欢的每一部漫画更新都不错过。
            </p>
            <div className="mt-5 flex gap-3">
              {['ri-wechat-line', 'ri-qq-line', 'ri-weibo-line', 'ri-mail-line'].map((icon) => (
                <a
                  key={icon}
                  href="#top"
                  aria-label="社交媒体"
                  className="flex h-10 w-10 items-center justify-center rounded-full bg-background-50/10 text-background-50 transition-colors hover:bg-background-50 hover:text-primary-700"
                >
                  <i className={`${icon} text-lg`} />
                </a>
              ))}
            </div>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-sm font-semibold text-background-50">快捷导航</h4>
            <ul className="mt-4 flex flex-col gap-2.5">
              {quickNav.map((n) => (
                <li key={n.href}>
                  <a
                    href={n.href}
                    className="text-sm text-background-100/75 transition-colors hover:text-background-50"
                  >
                    {n.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-sm font-semibold text-background-50">热门分类</h4>
            <ul className="mt-4 flex flex-col gap-2.5">
              {categories.slice(0, 6).map((c) => (
                <li key={c.id}>
                  <a
                    href="#categories"
                    className="text-sm text-background-100/75 transition-colors hover:text-background-50"
                  >
                    {c.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-sm font-semibold text-background-50">关于樱花漫画</h4>
            <p className="mt-4 text-sm leading-relaxed text-background-100/75">
              我们专注于为漫画爱好者提供省心的追更体验。如你需要帮助，欢迎通过页面底部的联系方式与我们取得联系。
            </p>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-background-50/15 pt-6 text-xs text-background-100/60 sm:flex-row">
          <p>© 2026 樱花漫画 · 追更提醒服务。仅用于内容与功能展示。</p>
          <p>追更不怕漏 · 更新第一时间提醒</p>
        </div>
      </div>
    </footer>
  );
}